import styled from "styled-components";
import {Text1, Title1} from "../../../styles/components";
import {Button} from "../../Button/styles";

export const Content = styled.div`
  margin: 25px 0;
  display: flex;
  flex-direction: column;
  gap: 50px;
`

export const Content2 = styled.div`
  margin-top: 150px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 100px;
`

export const Title = styled(Title1)`
  color: #000;
`

export const Text = styled(Text1)`
  color: ${({theme}) => theme.colors.primaryFont};
`

export const RedText = styled(Text1)`
  color: ${({theme}) => theme.colors.red};
  font-weight: 600;
`

export const List = styled.ul`
  font-size: 24px;
  & li {
    list-style-position: inside;
    list-style-type: decimal;  
  }
`

export const Image = styled.img`
  width: 60%;
`

export const DownloadButton = styled(Button)`
  width: 375px;
  padding: 20px 30px;
  border-radius: 40px 40px 40px 0;
  margin-bottom: 1rem;
  text-transform: uppercase;
`

export const HelpButton = styled(Button)`
  width: 375px;
  padding: 20px 30px;
  border-radius: 40px 40px 0 40px;
  text-transform: uppercase;
`